import React, { useContext, useEffect, useState } from 'react';
import {
  ShoppingCart, LogOut, ShoppingBag, Settings, PhoneCall,User,History 
} from 'lucide-react';
import { CartContext } from '../CartContext';
const API_BASE_URL = window._config?.apiBaseUrl || '';
 const DATABASE_KEY = window._config?.databaseKey || '';
console.log('API_BASE_URL:', API_BASE_URL);
console.log('DATABASE_KEY:', DATABASE_KEY);
console.log('window._config:', window._config);

export default function Navbar({ user, setPage, onLogout }) {
  const { itemCount, totalQuantity } = useContext(CartContext);
  const [companyName, setCompanyName] = useState('Shop');
  const [showModal, setShowModal] = useState(false);
  const [companyDetails, setCompanyDetails] = useState(null);

  useEffect(() => {
    fetch('/config.json')
      .then(res => res.json())
      .then(data => setCompanyName(data.CompanyName || 'Shop'))
      .catch(() => setCompanyName('Shop'));
  }, []);

  
console.log(API_BASE_URL)
  const handleContactClick = () => {
    setShowModal(true);
    if (!companyDetails) {
      fetch('/config.json')
        .then(res => res.json())
        .then(configData => {
          const dbKey = configData.databaseKey || '';
          const apiUrl = configData.apiBaseUrl || API_BASE_URL;
          return fetch(
            `${apiUrl}/CompanyDetailsAPI?user=admin&databaseKey=${encodeURIComponent(dbKey)}`
          );
        })
        .then(res => res.json())
        .then(data => {
          const info = data?.CompanyDetailsAPIjs?.Table?.[0];
          setCompanyDetails(info || null);
        })
        .catch(err => {
          console.error('Failed to fetch contact details:', err);
          setCompanyDetails(null);
        });
    }
  };

  return (
   <>
  {/* 🌸 PREMIUM NAVBAR */}
  <header className="sticky top-0 z-30 bg-white/70 backdrop-blur-xl border-b border-gray-100 shadow-sm">
    <nav className="container mx-auto px-6">
      <div className="flex items-center justify-between h-20">

        {/* Logo */}
        <div className="flex-shrink-0">
          <a
            href="#"
            onClick={(e) => {
              e.preventDefault();
              if (user) setPage('products');
            }}
            className="flex items-center space-x-3 group"
          >
            <div className="p-2 rounded-xl bg-teal-50 group-hover:bg-teal-100 transition">
              <ShoppingBag className="h-7 w-7 text-teal-600" />
            </div>
            <span className="hidden sm:inline text-xl font-semibold text-gray-800 tracking-wide">
              {companyName}
            </span>
          </a>
        </div>

        {/* Right Section */}
        <div className="flex items-center space-x-3 sm:space-x-5">

          {!user && (
            <button
              onClick={() => setPage('home')}
              className="hidden sm:block text-gray-600 hover:text-teal-600 
                         font-medium px-4 py-2 rounded-lg 
                         transition-all duration-200 hover:bg-teal-50"
            >
              Home
            </button>
          )}

          {user && (
            <button
              onClick={() => setPage('products')}
              className="hidden sm:block text-gray-600 hover:text-teal-600 
                         font-medium px-4 py-2 rounded-lg 
                         transition-all duration-200 hover:bg-teal-50"
            >
              Florals
            </button>
          )}

          {/* Cart */}
          {user && (
            <button
              onClick={() => setPage('cart')}
              className="relative p-2 rounded-full hover:bg-teal-50 transition"
            >
              <ShoppingCart className="h-6 w-6 text-gray-700 hover:text-teal-600" />
              {totalQuantity > 0 && (
                <span className="absolute -top-1 -right-1 
                                 bg-gradient-to-r from-teal-500 to-emerald-500 
                                 text-white text-[10px] font-semibold 
                                 rounded-full px-2 py-0.5 
                                 shadow-md border border-white">
                  {itemCount}/{totalQuantity}
                </span>
              )}
            </button>
          )}
    {user && (
  <button
    onClick={() => setPage('profile')}
    className="flex items-center p-2 rounded-full hover:bg-teal-50 transition"
    title="Your Profile"
  >
    <User className="h-5 w-5 text-teal-600" />
  </button>
)}

{user && (
  <button
    onClick={() => setPage("order-history")}
    className="relative p-2 rounded-full hover:bg-teal-50 transition"
    title="Order History"
  >
    <History className="h-6 w-6 text-gray-700 hover:text-teal-600" />
  </button>
)}

          {/* Contact */}
         <button
  onClick={handleContactClick}
  className="relative p-2 rounded-full bg-gray-100 hover:bg-gray-200 transition"
  title="Contact Us"
>
  <PhoneCall className="h-6 w-6 text-gray-600" />


</button>

          {/* User Section */}
          {user ? (
            <div className="flex items-center space-x-3">
              <span className="hidden md:block text-sm font-medium text-gray-700">
                Hi, <span className="text-teal-600">{user.customer}</span>
              </span>
              <button
                onClick={onLogout}
                className="flex items-center space-x-2 
                           bg-gradient-to-r from-red-500 to-red-600 
                           hover:from-red-600 hover:to-red-700
                           text-white text-sm font-semibold 
                           py-2 px-4 rounded-xl 
                           transition-all duration-300 
                           shadow-md hover:shadow-lg"
              >
                <LogOut className="h-4 w-4" />
              </button>
            </div>
          ) : (
            <span className="text-gray-600 font-medium">Welcome</span>
          )}
        </div>
      </div>
    </nav>
  </header>

  {/* 🌸 MODERN CONTACT MODAL */}
  {showModal && (
    <div className="fixed inset-0 bg-black/40 backdrop-blur-sm z-40 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-lg p-8 relative animate-fadeIn">

        <button
          onClick={() => setShowModal(false)}
          className="absolute top-4 right-4 text-gray-400 hover:text-red-500 text-lg"
        >
          ✕
        </button>

        <h2 className="text-3xl font-bold mb-6 text-center text-teal-600">
          Contact Us
        </h2>

        {companyDetails ? (
          <div className="space-y-3 text-gray-700 text-sm leading-relaxed">
            <p className="font-semibold text-lg text-gray-900">
              {companyDetails.Comname}
            </p>
            <p>{companyDetails.PropName}</p>
            <p>{companyDetails.Address1}</p>
            <p>{companyDetails.Address2}</p>
            <p>
              {companyDetails.City}, {companyDetails.State} - {companyDetails.Pincode}
            </p>
            <p>
              {companyDetails.Phone} | {companyDetails.Mobile}
            </p>
            <p>
              <span className="font-medium text-teal-600">Email:</span>{" "}
              {companyDetails.Email}
            </p>
          </div>
        ) : (
          <p className="text-red-500 text-center">
            Unable to load contact details.
          </p>
        )}
      </div>
    </div>
  )}
</>

  );
}

